// import React, { useEffect, useRef, useState } from 'react';
// import { useDispatch, useSelector } from 'react-redux';
// import { useLocation, useHistory } from 'react-router-dom';

import './Page404.scss';
import Logo2 from '../../components/Logo/Logo2';


const PageError = ({ type = 'diagram' }) => {
    document.title = 'Page Not Found | DB Design';

    return (
        <div className="check-email-box">
            <Logo2 />
            <div className='check-email'>
                <div className="check-email-title not-found" style={{ fontSize: '40px' }}>404</div>
                <div className='check-email-text-wrap'>
                    {/* This quick share link is invalid or was entered incorrectly. */}
                    <p className="check-email-text verified">{type === 'quick-share' ? 'This link is invalid or was entered incorrectly.' : 'Something went wrong.'}</p>
                </div>
                <a href="/" className={`check-email-action not-found ${type === 'quick-share' ? 'quick-share' : ''}`}>
                    <span>{type === 'quick-share' ? 'Back to Playground' : 'Please try later'}</span>
                </a>
            </div>
        </div >
    );
};

export default PageError;
